
import Vue, { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VAutocomplete from 'vuetify/lib/components/VAutocomplete/VAutocomplete';
@Component
export default class BaseAutoComplete extends Vue {
@Prop({
    type: Boolean,
    default: false
}) clearable!: boolean;

@Prop({ type: Boolean, default: true }) dense!: boolean;
@Prop({ type: Boolean, default: true }) filled!: boolean;
@Prop({ type: Boolean, default: true }) isEmphasized!: boolean;
@Prop({ type: String, default: '' }) appendIcon!: string;
@Prop({ type: String, default: '' }) label!: string;
@Prop({ type: String, default: undefined }) placeholder!: string;

// Use computed properties to avoid unnecessary recalculations
get computedAppendIcon(): string {
    return this.appendIcon || 'fa-solid fa-chevron-down';
}

get computedClearable(): boolean {
    return this.clearable;
}

// Merge the classes in a more streamlined manner
get classes(): object {
    return {
    ...VAutocomplete.options.computed.classes.call(this),
    'base-select': true,
    'base-auto-complete': true,
    'emphasized-select': this.isEmphasized
    };
}

render(h: CreateElement): VNode {

    const autoComplete = h(VAutocomplete,
            {
                class: this.classes,
                props: {
                    ...this.$props,
                    ...this.$attrs,
                    filled: this.filled,
                    dense: this.dense,
                    appendIcon: this.computedAppendIcon,
                    placeholder: this.placeholder,
                    label: ''
                },
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
                attrs: this.$attrs
            },
            this.$slots.default
        );

    return h('div', { class: 'select-wrapper' }, [
                this.label
                    ? h('div', { class: 'select-title' }, this.label)
                    : null,
                autoComplete
            ]);
}
}
